<template>
	<div>
		<div class="list-item" v-for="(currentItem, index) in defects" :key="index">
			<el-row>
				<el-col :span="16">
					<div class="image-view">
						<img :src="currentItem.img" height="285" width="285" @error="nofindImg()" />
						<div class="box" :style="getRectCoord(currentItem)"></div>
					</div>
					<!-- <canvas ref="defect_monitor_canvas" height="285" width="285"></canvas> -->
				</el-col>
				<el-col :span="8">
					<ul class="details_view">
						<li>
							<label for>位置：</label>
							<span> {{ currentItem.meter | fil }}</span>
						</li>
						<li>
							<label for>检测面：</label>
							<span v-text="currentItem.model_side_text"></span>
						</li>
						<li>
							<label for>缺陷类型：</label>
							<span v-text="currentItem.type_text"></span>
						</li>
						<li>
							<label for>面积：</label>
							<span v-text="currentItem.area"></span>
						</li>
						<li>
							<label for>张号：</label>
							<span v-text="currentItem.sheet_index"></span>
						</li>
						<li>
							<label for>联号：</label>
							<span v-text="currentItem.col"></span>
						</li>
						<li>
							<label for>强度：</label>
							<span v-text="currentItem.energy"></span>
						</li>
					</ul>
				</el-col>
			</el-row>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
	import { getDefectRequest, getDefectImageUrlByMd5 } from '@/network/requests/defect'
	import { defectTypeRequest } from '@/network/requests/defectType'
	import { modelRequest } from '@/network/requests/model'
	import { modelSideRequest } from '@/network/requests/modelSide'
	export default {
		props: {
			/**
			 * 批次Id。
			 */
			id: {
				type: String,
			},
		},
		data() {
			return {
				defects: [],
			}
		},
		filters: {
			fil(val) {
				if (!val) return ''
				const value = val / 1000
				return `${value}米`
			},
		},
		methods: {
			/**
			 * 图片加载错误的蒙版图。
			 */
			nofindImg() {
				const img = event.srcElement
				img.src = require('@/assets/images/img.png')
				img.onerror = null //防止一直跳动
			},
			getRectCoord(record) {
				console.log(record)
				return {
					left: 285 / 2 - record.size_cx / 2 + 'px',
					top: 285 / 2 - record.size_cy / 2 + 'px',
					width: record.size_cx + 'px',
					height: record.size_cy + 'px',
				}
			},
			/**
			 * 获取最新的缺陷记录。
			 */
			async getNewstDefectData() {
				var defects = []

				try {
					//获取5个缺陷记录。
					defects = (
						await getDefectRequest(this.id).queryPage({
							page: 1,
							pagesize: 5,
							filter: undefined,
							sort: { _id: -1 },
						})
					).data._embedded

					//获取批次对应的缺陷类型。
					var defectTypes = await defectTypeRequest.queryAll({ roll_id: this.id })
					//获取批次对应的模板。
					var model = (await modelRequest.queryAll({ roll_id: this.id }))[0]
					//获取模板对应的检测面。
					var modelSides = await modelSideRequest.queryAll({ model_id: model._id.$oid })

					//合并缺陷图片记录。
					var tempArray = []
					for (var item of defects) {
						var img = await getDefectImageUrlByMd5(item.md5, this.id)
						var type = defectTypes.find(t => t.type_index == item.type_index)
						var ms = modelSides.find(t => t.side_index == item.side_index)
						tempArray.push({
							...item,
							img,
							type_text: type.display,
							model_side_text: ms?.name,
						})
					}

					this.defects = tempArray
				} catch (error) {
					console.error(error)
				}
			},
		},
		async created() {
			await this.getNewstDefectData()
		},
	}
</script>

<style lang="less" scoped>
	.image-view {
		height: 285px;
		width: 285px;
		position: relative;
	}
	.box {
		position: absolute;
		border: 0.5px #f00 solid;
	}

	.list-item {
		width: 455px;
		float: left;
		padding: 15px 0 15px 15px;
		margin-bottom: 15px;
		box-sizing: border-box;
	}

	.list-item:hover {
		background-color: #eee;
	}

	.details_view li {
		list-style: none;
	}
</style>
